/**
 * Light/dark theme management. The active theme is stored in localStorage
 * and applied as `data-theme` on <html> (CSS token overrides) — index.html
 * sets it before first paint to avoid flashing. Subscribers (viewer basemap,
 * flight manager label colors) are notified on change.
 */

const STORAGE_KEY = 'frm-theme';
const listeners = new Set();

export function getTheme() {
  const stored = localStorage.getItem(STORAGE_KEY);
  return stored === 'dark' ? 'dark' : 'light';
}

export function setTheme(theme) {
  const value = theme === 'dark' ? 'dark' : 'light';
  localStorage.setItem(STORAGE_KEY, value);
  document.documentElement.dataset.theme = value;

  // Browser-Chrome (PWA-Statusleiste) mitfärben
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.content = value === 'dark' ? '#14161c' : '#f5f6f8';

  for (const listener of listeners) {
    try {
      listener(value);
    } catch (error) {
      console.warn('Theme listener failed:', error);
    }
  }
}

export function onThemeChange(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
